import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    useTheme
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ValidationErrorDialog = ({ open, onClose, message, title = "Input Validation" }) => {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${theme.palette.background.default})`,
                    border: `1px solid ${theme.palette.divider}`,
                    boxShadow: theme.shadows[8]
                }
            }}
        >
            <DialogTitle 
                sx={{ 
                    textAlign: 'center', 
                    pb: 1, 
                    pt: 3,
                    color: theme.palette.error.main 
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    <ErrorOutlineIcon fontSize="large" />
                    <Typography variant="h6" fontWeight="bold">
                        {title}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', px: 3, pb: 2 }}>
                <Typography 
                    variant="body1" 
                    sx={{ 
                        color: theme.palette.text.primary,
                        lineHeight: 1.6,
                        whiteSpace: 'pre-line' // Allow line breaks in error messages
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 1 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        borderRadius: 2,
                        px: 4,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-1px)',
                        }
                    }}
                >
                    Got it
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ValidationErrorDialog;